module.exports = __webpack_public_path__ + "static/img/serverShop6.423e984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop6.png
// module id = 2TH2
// module chunks = 0